<template>
  <button :disabled="disabled" :class="{ '!opacity-50 !cursor-not-allowed': disabled }">
    <slot />
  </button>
</template>
<script setup lang="ts">
  defineProps<{
    disabled?: boolean;
  }>();
</script>
<style lang="scss" scoped>
  button {
    @apply py-2 rounded-lg justify-center items-center inline-flex w-full;
    max-width: 260px;
  }
</style>
<style lang="scss">
  button[disabled] {
    opacity: 0.8;
    pointer-events: none;
    cursor: not-allowed !important;
  }
</style>
